var render, staticRenderFns
import script from "./DynamicField.vue?vue&type=script&lang=ts&"
export * from "./DynamicField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a653d0",
  null
  
)

export default component.exports